'use es6';

import { createSelector } from 'reselect';
import { OrderedMap } from 'immutable';
import { getContent, getContentHasTranslatedContent, getContentTranslatedContent } from './contentSelectors';
import ModalNames from '../constants/ModalNames';
import { PageActionTypes } from '../constants/header';
import PageForModals from '../models/PageForModals';

// these actions aren't synced with their
// language variations, and should allow
// a user to select a certain variation
// or master from the list.
// For more context: https://git.hubteam.com/HubSpot/CMS-Publishing-Teams/issues/566
const MODALS_WITH_PAGE_SELECTOR = [ModalNames[PageActionTypes.CHANGE_AUDIENCE_ACCESS], ModalNames[PageActionTypes.CHANGE_CONTENT_ACCESS], ModalNames[PageActionTypes.CLONE], ModalNames[PageActionTypes.PUBLISHING_OPTIONS], ModalNames[PageActionTypes.UNPUBLISHING_OPTIONS]];
export const getModalsDisplay = state => state.modalsDisplay;
export const getOpenModalName = createSelector([getModalsDisplay], modalsDisplay => modalsDisplay.openModalName);
export const getOpenModalOverrides = createSelector([getModalsDisplay], modalsDisplay => modalsDisplay.modalOverrides);
export const getModalErrors = createSelector([getModalsDisplay], modalsDisplay => modalsDisplay.errors);
export const getModalRelevantEntities = createSelector([getContent, getContentHasTranslatedContent, getContentTranslatedContent, getOpenModalName], (content, hasTranslatedContent, translatedContent, openModalName) => {
  const mainContent = PageForModals.fromJS(content.get('data').toObject());
  if (MODALS_WITH_PAGE_SELECTOR.includes(openModalName) && hasTranslatedContent) {
    return translatedContent.mapEntries(([__, tc]) => [tc.id, PageForModals.fromTranslatedContent(tc, mainContent, translatedContent)]).set(mainContent.id, mainContent).sortBy(c => c.languageName);
  }
  return OrderedMap([[mainContent.id, mainContent]]);
});
export const getSocialComopserOpen = createSelector([getModalsDisplay], modalsDisplay => modalsDisplay.socialComposerOpen);
export const getSocialComposerParams = createSelector([getModalsDisplay], modalsDisplay => modalsDisplay.socialComposerParams);
export const getAdsPanelOpen = createSelector([getModalsDisplay], modalsDisplay => modalsDisplay.adsPanelOpen);